import React from "react";
import {
  Button,
  GridColumn,
  GridContainer,
  GridRow,
} from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import OrderDataBlock from "../OrderDataBlock";
import PricingDetailsBlock from "../PricingDetailsBlock";
import Anchor from "../../Anchor";
import PropTypes from "prop-types";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const OrderSummaryBlock = props => {
  const {
    orderConfirmationData: { orderLevelDetails, pricingDetails },
    orderId,
  } = props;

  return (
    <GridContainer className="nw-orderconfirm-summary-block-container">
      <GridRow className="nw-orderconfirm-summary-title-row">
        <GridColumn className="nw-orderconfirm-summary-block-title">
          {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.TITLE}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-summary-discription">
        <GridColumn className="nwc-grid-col-sm-4">
          <OrderDataBlock.component
            orderLevelDetails={orderLevelDetails}
            total={pricingDetails.total}
          />
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-4 nw-orderconfirm-summary-block-trackorder-col">
          <div className="nw-orderconfirm-summary-col-btn">
            <Anchor.component
              className="nwc-btn-primary nw-orderconfirm-summary-block-trackorder-btn"
              href={`${
                ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.ORDER_URL_ENDPOINT
              }${orderId}`}
              to={`${
                ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.ORDER_URL_ENDPOINT
              }${orderId}`}
              target="_self"
            >
              {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.TRACK_ORDER_BTN}
            </Anchor.component>
            <Button
              className="nwc-btn-secondary nw-orderconfirm-summary-block-print-btn nw-desktop-only"
              onClick={window.print}
            >
              {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.PRINT_ORDER_BTN}
            </Button>
          </div>
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-4">
          <PricingDetailsBlock.component pricingDetails={pricingDetails} />
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

OrderSummaryBlock.propTypes = {
  orderConfirmationData: PropTypes.shape({}).isRequired,
  orderId: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderSummaryBlock,
  component: OrderSummaryBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderSummaryBlock/index.js